import { Outlet, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { selectGlobalDataState } from '../../features/global/globalDataSlice'
import React from 'react'
import { selectLoginState } from '../../features/login/loginSlice';

const PrivateRoute = () => 
{
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const loginSliceState = useSelector(selectLoginState)

    let auth = {
        token: (globalDataSliceState.token !== "" || loginSliceState.token !== "") ? true : false
    }

    return(
        auth.token ? <Outlet/> : <Navigate to='/login'/>
    )
}

export default PrivateRoute

